import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const COOKIE_KEY = 'obule_cookie_consent'

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(COOKIE_KEY)
      if (stored !== 'accepted') {
        setVisible(true)
      }
    } catch (e) {
      // If localStorage is unavailable, still show the banner
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    try {
      window.localStorage.setItem(COOKIE_KEY, 'accepted')
    } catch (e) {
      // Ignore storage errors
    }
    setVisible(false)
  }

  if (!visible) {
    return null
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 pointer-events-none">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4">
        <div className="pointer-events-auto rounded-2xl bg-slate-900/95 text-white shadow-2xl border border-slate-800/80 px-4 py-4 sm:px-6 sm:py-5 flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1">
            <p className="text-sm sm:text-base font-medium mb-1">
              We use cookies to improve your experience.
            </p>
            <p className="text-xs sm:text-sm text-slate-300 leading-relaxed font-light">
              Obule uses cookies and similar technologies to remember your preferences, analyze
              traffic, and personalize content. By clicking Accept, you agree to our use of cookies
              as described in our{' '}
              <Link
                to="/privacy"
                className="text-emerald-400 hover:text-emerald-300 underline underline-offset-2"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </div>
          <div className="flex gap-3 justify-end items-center">
            <Link
              to="/privacy"
              className="text-xs sm:text-sm font-medium text-slate-200 hover:text-white underline underline-offset-2"
            >
              Cookie Policy
            </Link>
            <button
              type="button"
              onClick={handleAccept}
              className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-xs sm:text-sm font-semibold text-slate-900 bg-emerald-400 hover:bg-emerald-300 shadow-lg transition-colors duration-200"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner

